import { render } from "./PaasListStatus.vue?vue&type=template&id=589e7c60&scoped=true"
import script from "./PaasListStatus.vue?vue&type=script&lang=js"
export * from "./PaasListStatus.vue?vue&type=script&lang=js"

import "./PaasListStatus.vue?vue&type=style&index=0&id=589e7c60&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589e7c60"]])

export default __exports__